
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSignFireAlarmButton as ObiSignFireAlarmButtonElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sign-fire-alarm-button.js';
 
 
 

 
 export const ObiSignFireAlarmButton = createComponent({
   react: React,
   tagName: 'obi-sign-fire-alarm-button',
   elementClass: ObiSignFireAlarmButtonElement,
   events: {
     
   }
  });
 
 